import { render, staticRenderFns } from "./SecretaryForm.vue?vue&type=template&id=841fd8c4&"
import script from "./SecretaryForm.vue?vue&type=script&lang=js&"
export * from "./SecretaryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports